import { render, staticRenderFns } from "./ADretouches.vue?vue&type=template&id=ec795860"
import script from "./ADretouches.vue?vue&type=script&lang=js"
export * from "./ADretouches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports